var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          style: _vm.styles,
          attrs: {
            filterable: "",
            multiple: _vm.multiple,
            placeholder: _vm.placeholder,
            clearable: "",
          },
          on: { clear: _vm.handlerClear, change: _vm.handlerChange },
          model: {
            value: _vm.val,
            callback: function ($$v) {
              _vm.val = $$v
            },
            expression: "val",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: {
              label: item.label,
              value: item.value,
              disabled: item.disabled,
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }